import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const TeamPage = lazy(() => import("@/features/dashboard/pages/team"));

export const Route = createFileRoute("/(app)/dashboard/organisation/people")({
  component: () => (
    <Suspense fallback={<div className="text-muted-foreground text-sm">Loading…</div>}>
      <TeamPage />
    </Suspense>
  ),
});
